const platformsModel = vm => ({
  title: vm.$gettext('Platforms'),
  endpoint: 'platforms',
  allowNew: true,
  shared: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'slug',
      label: vm.$gettext('Slug'),
      sortable: true,
      editable: true,
      required: false,
      description: vm.$gettext('Must be ONLY one lowercase word')
    },
    {
      key: 'grant_type',
      label: vm.$gettext('Grant Type'),
      sortable: true,
      editable: true,
      required: false,
      description: vm.$gettext('Must be one valid OAuth lowercase word')
    },
    {
      key: 'oauth_url',
      label: vm.$gettext('OAuth URL'),
      sortable: true,
      editable: true,
      required: false,
      description: vm.$gettext('Usually something like: https://thirdpartywebsiteapi/oauth/token')
    },
    {
      key: 'client_id',
      label: vm.$gettext('Client ID'),
      sortable: true,
      editable: true,
      required: false
    },
    {
      key: 'client_secret',
      label: vm.$gettext('Client Secret'),
      sortable: true,
      editable: true,
      required: false
    },
    {
      key: 'redirect_uri',
      label: vm.$gettext('Redirect URI'),
      sortable: true,
      editable: true,
      required: false
    },
    {
      key: 'active',
      label: vm.$gettext('Active'),
      sortable: true,
      editable: true,
      type: Boolean,
      required: false
    }
  ],
  filters: ['id', 'name', 'slug']
})

export default platformsModel
